{
  "next_step": "下一步",
  "confirm": "确定",
  "cancel": "取消",
  "skip": "跳过",
  "action": "操作",
  "amount": "金额",
  "details": "详情",
  "modify_success": "修改成功",
  "submit": "提交",
  "resend": "重新发送",
  "reinput": "重新输入",
  "currency": "币种",
  "acknowledged": "知道了",
  "i18n_example": "国际化示例",
  "total_count": "共 {{total}} 条",
  "error": "错误",
  "forbidden": "您无权访问",
  "not_found": "您访问的资源不存在",
  "payload_too_large": "上传文件过大",
  "server_error": "系统繁忙，请稍候再试",
  "system_busy": "系统繁忙，请稍后再试",
  "success": "成功",
  "search_placeholder": "搜索",
  "collapse": "收起",
  "expand": "展开"
}
